/**
=========================================================
* Annotation Portal React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base border styles for the Annotation Portal React.
 * You can add new border width, border color or border radius using this file.
 * You can customized the borders value for the entire Annotation Portal React using thie file.
 */

// Annotation Portal React Base Styles
import colors from "assets/theme/base/colors";

// Annotation Portal React Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { grey } = colors;

const borders = {
  borderColor: grey[300],

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(1.6),
    sm: pxToRem(2),
    md: pxToRem(8),
    lg: pxToRem(10),
    xl: pxToRem(14),
    xxl: pxToRem(20),
    section: pxToRem(160),
  },
};

export default borders;
